module.exports = __webpack_public_path__ + "img/2.c0b9eac7.png";